module.exports = __webpack_public_path__ + "static/media/callme.81b6bc9f.png";